exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-8d17f0a8] {\n  padding: 0.5rem 0 0.4rem 0;\n}", ""]);

// exports
